import SelectRadio from '@/components/shared/SelectRadio';
import { InputHTMLAttributes } from 'react';
import { UseFormRegister, FieldValues, UseFormSetValue } from 'react-hook-form';
import useClaimCreateStore from '@/store/claimCreateStore';
import { CARE_TYPE_CONFIG } from '@/constants';
import { IFeatureCategory } from '@/types';

type IProps = {
  onOptionSelect: (value?: IFeatureCategory) => void;
  selectedValue?: string;
  register: UseFormRegister<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
};

const ClaimCategoryInput = (
  props: IProps & InputHTMLAttributes<HTMLInputElement>
) => {
  const { selectedValue, register, setValue, ...rest } = props;
  const currentPatientDetails = useClaimCreateStore(
    (state) => state.currentPatientDetails
  );

  return (
    <div className="flex flex-col gap-4">
      {Object.keys(currentPatientDetails?.featureCategories ?? {}).map(
        (categoryName) => {
          const category =
            currentPatientDetails?.featureCategories?.[categoryName];
          const icon = CARE_TYPE_CONFIG.get(category?.typeOfCare ?? '')?.icon;
          return (
            <SelectRadio
              key={categoryName}
              id={categoryName}
              value={category?.typeOfCare}
              title={category?.text}
              description={category?.subtext}
              icon={<img className="w-12 h-12" src={icon} />}
              selected={selectedValue === category?.typeOfCare}
              {...register('typeOfCare', {
                required: 'Please select a claim category',
              })}
              // kept it outside the register to avoid overriding the value by the last value of Array.map()
              onChange={() => {
                props.onOptionSelect(category);
                setValue('typeOfCare', category?.typeOfCare);
              }}
              name="typeOfCare"
              {...rest}
            />
          );
        }
      )}
    </div>
  );
};

export default ClaimCategoryInput;
